import { DEFI_EXCHANGES } from "../../../data/defi-exchanges";
import {
  CoinTickersMapped,
  CoinTickersResult,
} from "../../../types/api-results/coin-tickers";
import { useAllCoinsStatic } from "../../hooks/static-query-hooks/use-all-coins-static";
import { toNumber } from "../format-number";

const mapCoinTicker = (data: CoinTickersResult): CoinTickersMapped => {
  const allCoins = useAllCoinsStatic();
  const matchedCoin = allCoins.find((c) => c.id === data.coin_id);

  return {
    base: {
      id: data.coin_id,
      slug: matchedCoin?.slug || undefined,
      symbol: matchedCoin?.symbol || undefined,
      name: matchedCoin?.name || undefined,
      image: matchedCoin?.image || undefined,
    },
    target: data.target,
    targetCoinId: data.target_coin_id,
    market: {
      name: data.market.name,
      identifier: data.market.identifier,
      slug: data.market.identifier.toLowerCase(),
      hasTradingIncentive: data.market.has_trading_incentive || false,
      logo: data.market.logo || undefined,
      isDex: DEFI_EXCHANGES.includes(data.market.name),
    },
    last: toNumber(data.last),
    volume: toNumber(data.volume),
    convertedLast: data.converted_last
      ? {
          btc: toNumber(data.converted_last.btc),
          eth: toNumber(data.converted_last.eth),
          usd: toNumber(data.converted_last.usd),
        }
      : undefined,
    convertedVolume: data.converted_volume
      ? {
          btc: toNumber(data.converted_volume.btc),
          eth: toNumber(data.converted_volume.eth),
          usd: toNumber(data.converted_volume.usd),
        }
      : undefined,
    trustScore: data.trust_score || undefined,
    bidAskSpreadPercentage: toNumber(data.bid_ask_spread_percentage),
    timestamp: data.timestamp ? new Date(data.timestamp) : undefined,
    lastTradedAt: data.last_traded_at
      ? new Date(data.last_traded_at)
      : undefined,
    lastFetchAt: data.last_fetch_at ? new Date(data.last_fetch_at) : undefined,
    isAnomaly: data.is_anomaly || false,
    isStale: data.is_stale || false,
    tradeUrl: data.trade_url || undefined,
  };
};

interface MapCoinTickersInput {
  data?: CoinTickersResult[];
}

export const mapCoinTickers = ({
  data,
}: MapCoinTickersInput): CoinTickersMapped[] | undefined => {
  if (!data) {
    return undefined;
  }

  return data.map((ticker) => mapCoinTicker(ticker));
};
